import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Topheader from "../../../../Layout/header/header";
import Sidebar from "../sidebar/sidebar";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Edit, ExpandMore, ExpandLess } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import Fade from "@mui/material/Fade";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
  fetchDsaOemAdminUrl,
  patchDSAOemAdminUrl,
  deleteDsaOemAdminUrl,
} from "../../../../Services/redux/DSAOemAdminUrl/DSAOemAdminActions";
import { fetchAdminCountriesDetails } from "../../../../Services/redux/Oem-admin-counties/OemAdminCountryDetailsActions";
import { fetchLegalLocaleDocsDetails } from "../../../../Services/redux/LocalesRedux/LegallocaleDocumentsActions";
import "./DSAComplaintUrl.css";
import { getConfig } from "../../../../config";

function DSAComplaintUrl() {
  const dispatch = useDispatch();
  const [dataFromChild, setDataFromChild] = useState("");
  const [dsaComplaintTableData, setDSAComplaintTableData] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editUrl, setEditUrl] = useState("");
  const [editCountry, setEditCountry] = useState("");
  const [editLanguage, setEditLanguage] = useState("en_US");
  const [expanded, setExpanded] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deletingRow, setDeletingRow] = useState(null);
  const [isAnimatingDelete, setIsAnimatingDelete] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const [newCountry, setNewCountry] = useState("");
  const [newLanguage, setNewLanguage] = useState("");
  const [urlError, setUrlError] = useState("");
  const [validateUrlError, setValidateUrlError] = useState(false);
  const [editUrlError, setEditUrlError] = useState("");
  const [languages, setLanguages] = useState([]);
  const [ defaultUrlEditing, setDefaultUrlEditing ] = useState("Edit URL"); 
  const [europeanCountries, setEuropeanCountries] = useState([]);
  const dsaComplaintURLS = useSelector(
    (state) => state.DSAOemAdminReducer.DSAComplaintData
  );
  const oemCountries = useSelector(
    (state) => state.oemAdminCountires.countries
  );
  const locales = useSelector((state) => state.oemAdminLocales.locales);

  const handleExpandClick = (country) => {
    setExpanded((prev) => ({
      ...prev,
      [country]: !prev[country],
    }));
  };

  useEffect(() => {
    dispatch(fetchAdminCountriesDetails());
    dispatch(fetchLegalLocaleDocsDetails());
  }, []);

  useEffect(() => {
    if (
      oemCountries &&
      locales &&
      oemCountries.length > 0 &&
      locales.length > 0
    ) {
      let langs = [...locales];
      setLanguages(langs);
      setEditLanguage(langs[0]);
      dispatch(fetchDsaOemAdminUrl());
    }
  }, [dispatch, oemCountries, locales]);

  useEffect(() => {
    if (dsaComplaintURLS && Object.keys(dsaComplaintURLS).length > 0) {
      const transformedData = transformDSAData(dsaComplaintURLS);
      setDSAComplaintTableData(transformedData);
    }
  }, [dsaComplaintURLS]);

  const changeNewEditLanguage = (value) => {
    const exists = dsaComplaintTableData.some((row) => {
      if (row.country === editCountry) {
        return row.locales.some((localeObj) => {
          const localeKey = Object.keys(localeObj)[0];
          // Exclude current editing row
          return localeKey === value;
        });
      }
      return false;
    });
    if (exists) {
      setEditUrlError(
        `URL is already present for ${editCountry} and ${value}`
      );
    } else {
       setEditLanguage(value);
      setEditUrlError("");
    }
  };

  const changeNewEditCountry = (value) => {
    const exists = dsaComplaintTableData.some((row) => {
      if (row.country === value) {
        return row.locales.some((localeObj) => {
          const localeKey = Object.keys(localeObj)[0];
          // Exclude current editing row
          return localeKey === editLanguage;
        });
      }
      return false;
    });
    if (exists) {
       const countryName =
        oemCountries.find((c) => c.iso3Code === value)?.name || value;
      setEditUrlError(
        `URL is already present for ${countryName} and ${editLanguage}`
      );
    } else {
      setEditCountry(value);

      setEditUrlError("");
    }
  };

  const handleCloseAddDialog = () => {
    setNewUrl("");
    setNewCountry("");
    setNewLanguage("");
    setUrlError("");
    setAddDialogOpen(false);
  };

  const handleCloseEditDialog = () => {
    setEditUrl("");
    setEditCountry("");
    setEditLanguage("");
    setUrlError("");
    setEditDialogOpen(false);
  };

  const createNewURL = () => {
    // Check for duplicate country-language
    const exists = dsaComplaintTableData.some((row) => {
      return (
        row.country === newCountry &&
        row.locales.some(
          (localeObj) => Object.keys(localeObj)[0] === newLanguage
        )
      );
    });
    if (exists) {
      setUrlError(
        `URL is already present for ${newCountry} and ${newLanguage}`
      );
      return;
    }
    const getPayload = createPayloadForEdit(newCountry, newLanguage, newUrl);
    dispatch(patchDSAOemAdminUrl(getPayload));
    setNewUrl("");
    setNewCountry("");
    setNewLanguage("");
    setUrlError("");
    setAddDialogOpen(false);
  };

  const checkEditUrl = (value) => { 
    setEditUrl(value);
    const urlRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
     const isValidUrl = urlRegex.test(value);
    if (value && !isValidUrl) {
      setEditUrlError("Please enter a valid URL.");
      setValidateUrlError(true);
    } else {
      setEditUrlError("");
      setValidateUrlError(false);
    }
  }

  const editMethod = () => {
    // Check for duplicate country-language (excluding current row)

    const getPayload = createPayloadForEdit(editCountry, editLanguage, editUrl);
    dispatch(patchDSAOemAdminUrl(getPayload));
    setEditDialogOpen(false);
  };

  const createPayloadForEdit = (country, language, url) => {
    const payload = {};
    payload["propertyKey"] = country==="default" ? `defaultDsaUrl` : `${country}:${language}`;
    payload["propertyValue"] = url;
    return payload;
  };

  const transformDSAData = (inputData) => {
    const result = [];
    const countryMap = {};
    // Always add defaultDsaUrl:en_US as the first row if present
    const defaultKey = Object.keys(inputData).find((key) =>
      key.startsWith("defaultDsaUrl")
    );
    if (defaultKey) {
      const defaultLocale = defaultKey.split(":")[1] || "en_US";
      result.push({
        country: "default",
        countryName: "Default URL",
        locales: [{ [defaultLocale]: inputData[defaultKey] }],
        isDefault: true, // flag for chip rendering
      });
    }

    Object.entries(inputData).forEach(([key, url]) => {
      if (key.startsWith("defaultDsaUrl")) return;
      const [country, locale] = key.split(":");
      if (!countryMap[country]) {
        countryMap[country] = [];
      }
      const localeObj = {};
      localeObj[locale || "default"] = url;
      countryMap[country].push(localeObj);
    });

    Object.entries(countryMap).forEach(([country, localesArr]) => {
      const countryName =
        oemCountries.find((c) => c.iso3Code === country)?.name || country;
      result.push({
        country,
        countryName,
        locales: localesArr,
      });
    });

    return result;
  };

  function handleDataFromChild(data) {
    setDataFromChild(data);
  }

  const handleDeleteClick = (rowData) => {
    setSelectedRow(rowData);
    setDeleteDialogOpen(true);
  };
  const handleEditClick = (rowData) => {
    setEditUrl(rowData.url);
    setEditCountry(rowData.country);
    setEditLanguage(rowData.language);
    rowData.isDefault ? setDefaultUrlEditing("Edit Default URL") : setDefaultUrlEditing("Edit URL");
    setEditUrlError("");
    setEditDialogOpen(true);
  };

  const isMatchingLocale = (localeObj, rowCountry) =>
    rowCountry === selectedRow.country &&
    Object.keys(localeObj)[0] === selectedRow.language &&
    localeObj[selectedRow.language] === selectedRow.url;

  const removeLocaleFromRow = (row) => ({
    ...row,
    locales: row.locales.filter((localeObj) => !isMatchingLocale(localeObj, row.country)),
  });

  const filterValidRows = (prev) => {
    return prev.map(removeLocaleFromRow).filter((row) => row.locales.length > 0);
  };

  const handleDeleteConfirm = () => {
    setIsAnimatingDelete(true);
    setDeletingRow(selectedRow);
    const createdPropertyKey = `${selectedRow.country}:${selectedRow.language}`;
    dispatch(deleteDsaOemAdminUrl(createdPropertyKey));
    // Wait for animation, then remove row
    setTimeout(() => {
      setDSAComplaintTableData(filterValidRows);
      setIsAnimatingDelete(false);
      setDeletingRow(null);
      setDeleteDialogOpen(false);
      setSelectedRow(null);
    }, 600); // Animation duration
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedRow(null);
  };

  const addNewURL = (url) => {
    setNewUrl(url); // Always update the field value
   const urlRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
    const isValidUrl = urlRegex.test(url);
    if (url && !isValidUrl) {
      setUrlError("Please enter a valid URL.");
      setValidateUrlError(true);
    } else {
      setUrlError("");
      setValidateUrlError(false);
    }
  };

  const AddNewCountries = (value) => {
    setNewCountry(value);
    if(!validateUrlError){
      setUrlError("");  
    }
  }

    const AddnewLanguage=(value)=>{
      setNewLanguage(value);
      if(!validateUrlError){
        setUrlError("");  
      }
    }

  useEffect(()=>{
    const ecuropeAnCountries = new Set(getConfig().CHECK_EUROPEAN_COUNTRIES);
    const filteredCountries = oemCountries.filter((country) =>
      ecuropeAnCountries.has(country.iso3Code)
    );
    setEuropeanCountries(filteredCountries);
  },[oemCountries])

  return (
    <>
      <Topheader />
      <Box
        sx={{
          marginTop: "3%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "-webkit-box",
          }}
        >
          <Sidebar
            sendDataToParent={handleDataFromChild}
            page="DSA Complaint URL"
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box
              className="notifications-main- section"
              sx={{ flexGrow: 1, marginLeft: "20px", width: "68%" }}
            >
              <Box
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                width="100%"
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    marginTop: "33px",
                    fontWeight: "500",
                  }}
                >
                  {dataFromChild} - Portfolio Settings
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "24px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  borderTop: "1px solid #12141533",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    marginTop: "5px",
                  }}
                >
                  DSA Complaint URL
                </Typography>
                <Button
                  sx={{
                    background: "221.2 83.2% 53.3%",
                    textTransform: "none",
                    height: "36px",
                    maxWidth: "none",
                    fontWeight: "500",
                    fontSize: "14px",
                    lineHeight: "16.41px",
                    width: "150px",
                  }}
                  variant="contained"
                  type="button"
                  onClick={() => {
                    setAddDialogOpen(true);
                  }}
                  disabled={sessionStorage.getItem("readonly_OemAdmin") === "true"}
                >
                  Add New URL
                </Button>
              </Box>
              <Box>
                 <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    fontSize: 14,
                    letterSpacing: "0px",
                    color: "#717273",
                  }}
                >
                 Configure and manage the official URLs required for Digital Services Act (DSA) complaints, ensuring users have a clear and compliant path to submit issues or reports.
                </Typography>
              </Box>
              <div>
                <TableContainer
                  component={Paper}
                  sx={{ marginTop: 3, marginBottom: 5 }}
                >
                  <Table>
                    <TableHead sx={{ backgroundColor: "#E8E8E8" }}>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            fontStyle: "SemiBold",
                            fontSize: "14px",
                            leadingTrim: "NONE",
                            lineHeight: "16px",
                            letterSpacing: "0.4px",
                          }}
                        >
                          Country
                        </TableCell>
                        <TableCell
                          sx={{
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            fontStyle: "SemiBold",
                            fontSize: "14px",
                            leadingTrim: "NONE",
                            lineHeight: "16px",
                            letterSpacing: "0.4px",
                          }}
                        >
                          URL
                        </TableCell>
                        <TableCell
                          sx={{
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            fontStyle: "SemiBold",
                            fontSize: "14px",
                            leadingTrim: "NONE",
                            lineHeight: "16px",
                            letterSpacing: "0.4px",
                          }}
                        >
                          Language
                        </TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dsaComplaintTableData && dsaComplaintTableData.length > 0 ? dsaComplaintTableData.map((row) => {
                        const firstLocale = row.locales[0];
                        const firstLocaleKey = Object.keys(firstLocale)[0];
                        const firstLocaleUrl = firstLocale[firstLocaleKey];
                        const restLocales = row.locales.slice(1); // Only locales after the first

                        return (
                          <React.Fragment key={row.country}>
                            {/* Main row */}
                            <Fade
                              in={
                                !(
                                  isAnimatingDelete &&
                                  deletingRow &&
                                  deletingRow.country === row.country &&
                                  deletingRow.language === firstLocaleKey &&
                                  deletingRow.url === firstLocaleUrl
                                )
                              }
                              timeout={600}
                            >
                              <TableRow style={{ position: "relative" }}>
                                <TableCell
                                  style={{
                                    position: "relative",
                                    background: "#fff",
                                  }}
                                >
                                  {/* Car animation overlay */}
                                  {isAnimatingDelete &&
                                    deletingRow &&
                                    deletingRow.country === row.country &&
                                    deletingRow.language === firstLocaleKey &&
                                    deletingRow.url === firstLocaleUrl && (
                                      <div className="car-animation">
                                      
                                      </div>
                                    )}
                                  {row.countryName} {row.country === "default" ? "" :(`(${row.locales.length})`)}
                                  {row.isDefault && (
                                    <Chip
                                      label="default URL"
                                      color="#E8E8E8"
                                      size="small"
                                      sx={{
                                        ml: 1,
                                        fontSize: "12px",
                                        height: "22px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>{firstLocaleUrl}</TableCell>
                                <TableCell>{firstLocaleKey}</TableCell>
                                <TableCell align="left" sx={{ height: "52px" }}>
                                  <IconButton
                                      size="small"
                                      sx={{ visibility: row.isDefault ? 'hidden' : 'visible' }}
                                      onClick={() =>
                                        handleDeleteClick({
                                          country: row.country,
                                          countryName: row.countryName,
                                          url: firstLocaleUrl,
                                          language: firstLocaleKey,
                                        })
                                      }
                                      disabled={sessionStorage.getItem("readonly_OemAdmin") === "true" || row.isDefault}
                                    >
                                      <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.5553 26C13.0664 26 12.6479 25.8259 12.2998 25.4778C11.9516 25.1296 11.7776 24.7111 11.7776 24.2222V12.6667H10.8887V10.8889H15.3331V10H20.6664V10.8889H25.1109V12.6667H24.222V24.2222C24.222 24.7111 24.0479 25.1296 23.6998 25.4778C23.3516 25.8259 22.9331 26 22.4442 26H13.5553ZM22.4442 12.6667H13.5553V24.2222H22.4442V12.6667ZM15.3331 22.4444H17.1109V14.4444H15.3331V22.4444ZM18.8887 22.4444H20.6664V14.4444H18.8887V22.4444Z"
                                          fill="#121415"
                                          fillOpacity="0.6"
                                        />
                                      </svg>
                                    </IconButton>
                                  <IconButton size="small" disabled={sessionStorage.getItem("readonly_OemAdmin") === "true"}>
                                    <Edit
                                      fontSize="small"
                                      onClick={() =>
                                        handleEditClick({
                                          country: row.country,
                                          url: firstLocaleUrl,
                                          language: firstLocaleKey,
                                          isDefault: !!row.isDefault,
                                        })
                                      }
                                    />
                                  </IconButton>

                                  {restLocales.length > 0 && (
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleExpandClick(row.country)
                                      }
                                      sx={{ ml: 1 }}
                                    >
                                      {expanded[row.country] ? (
                                        <ExpandLess fontSize="small" />
                                      ) : (
                                        <ExpandMore fontSize="small" />
                                      )}
                                    </IconButton>
                                  )}
                                </TableCell>
                                
                              </TableRow>
                            </Fade>
                            {/* Collapsed rows: ONLY restLocales */}
                            {restLocales.length > 0 &&
                              expanded[row.country] &&
                              restLocales.map((localeObj, idx) => {
                                const localeKey = Object.keys(localeObj)[0];
                                const localeUrl = localeObj[localeKey];
                                return (
                                  <Fade
                                    key={localeKey + idx}
                                    in={
                                      !(
                                        isAnimatingDelete &&
                                        deletingRow &&
                                        deletingRow.country === row.country &&
                                        deletingRow.language === localeKey &&
                                        deletingRow.url === localeUrl
                                      )
                                    }
                                    timeout={600}
                                  >
                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          opacity: 1,
                                          gap: 4,
                                          borderRightWidth: "1px",
                                          borderLeftWidth: "1px",
                                          paddingTop: "8px",
                                          paddingRight: "32px",
                                          paddingBottom: "8px",
                                          paddingLeft: "16px",
                                          fontFamily: "Roboto",
                                          fontWeight: 400,
                                          fontStyle: "Regular",
                                          fontSize: "14px",
                                          leadingTrim: "NONE",
                                          lineHeight: "20px",
                                          letterSpacing: "0.25px",
                                          verticalAlign: "middle",

                                          height: "52px",
                                        }}
                                      >
                                        <span style={{ display: "none" }}>
                                          {row.country} 
                                        </span>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          opacity: 1,
                                          gap: 4,
                                          borderRightWidth: "1px",
                                          borderLeftWidth: "1px",
                                          paddingTop: "8px",
                                          paddingRight: "32px",
                                          paddingBottom: "8px",
                                          paddingLeft: "16px",
                                          fontFamily: "Roboto",
                                          fontWeight: 400,
                                          fontStyle: "Regular",
                                          fontSize: "14px",
                                          leadingTrim: "NONE",
                                          lineHeight: "20px",
                                          letterSpacing: "0.25px",
                                          verticalAlign: "middle",

                                          height: "52px",
                                        }}
                                      >
                                        {localeUrl}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          opacity: 1,
                                          gap: 4,
                                          borderRightWidth: "1px",
                                          borderLeftWidth: "1px",
                                          paddingTop: "8px",
                                          paddingRight: "32px",
                                          paddingBottom: "8px",
                                          paddingLeft: "16px",
                                          fontFamily: "Roboto",
                                          fontWeight: 400,
                                          fontStyle: "Regular",
                                          fontSize: "14px",
                                          leadingTrim: "NONE",
                                          lineHeight: "20px",
                                          letterSpacing: "0.25px",
                                          verticalAlign: "middle",

                                          height: "52px",
                                        }}
                                      >
                                        {localeKey}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ height: "52px" }}
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleDeleteClick({
                                              country: row.country,
                                              countryName: row.countryName,
                                              url: localeUrl,
                                              language: localeKey,
                                            })
                                          }
                                          disabled={sessionStorage.getItem("readonly_OemAdmin") === "true"}
                                        >
                                          <svg
                                            width="36"
                                            height="36"
                                            viewBox="0 0 36 36"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M13.5553 26C13.0664 26 12.6479 25.8259 12.2998 25.4778C11.9516 25.1296 11.7776 24.7111 11.7776 24.2222V12.6667H10.8887V10.8889H15.3331V10H20.6664V10.8889H25.1109V12.6667H24.222V24.2222C24.222 24.7111 24.0479 25.1296 23.6998 25.4778C23.3516 25.8259 22.9331 26 22.4442 26H13.5553ZM22.4442 12.6667H13.5553V24.2222H22.4442V12.6667ZM15.3331 22.4444H17.1109V14.4444H15.3331V22.4444ZM18.8887 22.4444H20.6664V14.4444H18.8887V22.4444Z"
                                              fill="#121415"
                                              fillOpacity="0.6"
                                            />
                                          </svg>
                                        </IconButton>
                                        <IconButton size="small"  disabled={sessionStorage.getItem("readonly_OemAdmin") === "true"}>
                                          <Edit
                                            fontSize="small"
                                            onClick={() =>
                                              handleEditClick({
                                                country: row.country,
                                                url: localeUrl,
                                                language: localeKey,
                                              })
                                             
                                            }
                                          />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  </Fade>
                                );
                              })}
                          </React.Fragment>
                        );
                      }) : 
                        <TableRow>
                <TableCell colSpan={5} align="center">
                  No DSA Compalint URL Available
                </TableCell>
              </TableRow>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Box>
          </div>
        </Box>
      </Box>
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Delete URL</span>
          <IconButton onClick={handleDeleteCancel}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              background: "#E8E8E8",
              borderRadius: 1,
              mb: 2,
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ borderBottom: "0px" }}>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "12px",
                      leadingTrim: "NONE",
                      lineHeight: "16px",
                      letterSpacing: "0.4px",
                    }}
                  >
                    Country
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "12px",
                      leadingTrim: "NONE",
                      lineHeight: "16px",
                      letterSpacing: "0.4px",
                    }}
                  >
                    URL
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "12px",
                      leadingTrim: "NONE",
                      lineHeight: "16px",
                      letterSpacing: "0.4px",
                    }}
                  >
                    Language
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "24px",
                      letterSpacing: "0.1px",
                      color: "#121415",
                    }}
                  >
                    {selectedRow?.countryName}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "24px",
                      letterSpacing: "0.1px",
                      color: "#121415",
                    }}
                  >
                    {selectedRow?.url}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "24px",
                      letterSpacing: "0.1px",
                      color: "#121415",
                    }}
                  >
                    {selectedRow?.language}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <Typography
            sx={{
              mb: 1,
              fontFamily: "Roboto",
              fontWeight: 400,
              fontStyle: "Regular",
              fontSize: "14px",
              leadingTrim: "NONE",
              lineHeight: "140%",
              letterSpacing: "0.15px",
              color: "#2A2C2D",
            }}
          >
            Are you sure you wish to permanently remove this URL?
          </Typography>
          <Typography
            sx={{
              mb: 1,
              fontFamily: "Roboto",
              fontWeight: 400,
              fontStyle: "Regular",
              fontSize: "14px",
              leadingTrim: "NONE",
              lineHeight: "140%",
              letterSpacing: "0.15px",
              color: "#2A2C2D",
            }}
          >
            This action cannot be reversed.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "flex-end", pb: 2, marginRight: "21px" }}
        >
          <Button
            onClick={handleDeleteCancel}
            variant="outlined"
            sx={{
              width: 100,
              height: 36,
              borderRadius: "4px",
              angle: "0 deg",
              opacity: 1,
              gap: "8px",
              paddingTop: "10px",
              paddingRight: "14px",
              paddingBottom: "10px",
              paddingLeft: "14px",
              background: "#1214151A",
              fontFamily: "Roboto",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              leadingTrim: "NONE",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#2A2C2D",
              borderColor: "#12141533",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="outlined"
            color="error"
            sx={{ ml: 2, borderColor: "#E53935", color: "#E53935" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit URL Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontFamily: "Roboto",
            fontWeight: 500,
            fontStyle: "Medium",
            fontSize: "22px",
            leadingTrim: "NONE",
            lineHeight: "120%",
            letterSpacing: "0%",
            color: "#121415",
          }}
        >
          {defaultUrlEditing}
          <IconButton onClick={() => setEditDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2, mt: 1 }}>
            <Typography
              sx={{
                mb: 1,
                fontFamily: "Roboto",
                fontWeight: 600,
                fontStyle: "SemiBold",
                fontSize: "16px",
                leadingTrim: "NONE",
                lineHeight: "100%",
                letterSpacing: "0px",
                verticalAlign: "middle",
                color: "#2A2C2D",
              }}
            >
              Enter URL link <span style={{ color: "#E53935" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="URL@domain.com"
              value={editUrl}
              onChange={(e) => checkEditUrl(e.target.value)}
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  fontSize: "16px",
                  fontFamily: "Roboto",
                },
              }}
              error={!!editUrlError}
              helperText={editUrlError}
            />
            {/* Country and Language side by side */}
            <Box sx={{ display: "flex", gap: 2 }}>
              {editCountry !== "default" && (
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      mb: 1,
                      fontFamily: "Roboto",
                      fontWeight: 600,
                      fontStyle: "SemiBold",
                      fontSize: "16px",
                      leadingTrim: "NONE",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      verticalAlign: "middle",
                      color: "#2A2C2D",
                    }}
                  >
                    Select Country <span style={{ color: "#E53935" }}>*</span>
                  </Typography>
                  <Select
                    fullWidth
                    value={editCountry}
                    onChange={(e) => changeNewEditCountry(e.target.value)}
                    disabled
                    sx={{
                      mb: 3,
                      fontSize: "16px",
                      fontFamily: "Roboto",
                      background: "#fafafa",
                    }}
                    renderValue={(selected) =>
                      selected ? (
                        oemCountries.find((c) => c.iso3Code === selected)?.name
                      ) : (
                        <span style={{ color: "#757575" }}>Country</span>
                      )
                    }
                  >
                    <MenuItem value="">
                      <span style={{ color: "#757575" }}>Country</span>
                    </MenuItem>
                    {oemCountries.map((country) => (
                      <MenuItem key={country.iso3Code} value={country.iso3Code}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              )}
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontFamily: "Roboto",
                    fontWeight: 600,
                    fontStyle: "SemiBold",
                    fontSize: "16px",
                    leadingTrim: "NONE",
                    lineHeight: "100%",
                    letterSpacing: "0px",
                    verticalAlign: "middle",
                    color: "#2A2C2D",
                  }}
                >
                  Select Language <span style={{ color: "#E53935" }}>*</span>
                </Typography>
                <Select
                  fullWidth
                  value={editLanguage}
                  disabled
                  sx={{
                    mb: 3,
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    background: "#fafafa",
                  }}
                  onChange={(e) => changeNewEditLanguage(e.target.value)}
                  renderValue={(selected) => selected || ""}
                >
                  {languages.length > 0 &&
                    languages.map((lang) => (
                      <MenuItem key={lang} value={lang}>
                        {lang}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "flex-end", pb: 2, marginRight: "21px" }}
        >
          <Button
            onClick={handleCloseEditDialog}
            variant="outlined"
            sx={{
              width: 100,
              height: 36,
              borderRadius: "4px",
              angle: "0 deg",
              opacity: 1,
              gap: "8px",
              paddingTop: "10px",
              paddingRight: "14px",
              paddingBottom: "10px",
              paddingLeft: "14px",
              background: "#1214151A",
              fontFamily: "Roboto",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              leadingTrim: "NONE",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#2A2C2D",
              borderColor: "#12141533",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={editMethod}
            variant="contained"
            sx={{
              ml: 2,
              background: "#0070f3",
              fontWeight: 500,
              fontSize: "16px",
              fontFamily: "Roboto",
              borderRadius: "6px",
              px: 4,
            }}
            disabled={!editUrl || editUrlError !== ""}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New URL Dialog */}
      <Dialog
        open={addDialogOpen}
        onClose={handleCloseAddDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontFamily: "Roboto",
            fontWeight: 500,
            fontStyle: "Medium",
            fontSize: "22px",
            leadingTrim: "NONE",
            lineHeight: "120%",
            letterSpacing: "0%",
            color: "#121415",
          }}
        >
          <span>Add New URL</span>
          <IconButton onClick={handleCloseAddDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                mb: 1,
                fontFamily: "Roboto",
                fontWeight: 600,
                fontStyle: "SemiBold",
                fontSize: "16px",
                leadingTrim: "NONE",
                lineHeight: "100%",
                letterSpacing: "0px",
                verticalAlign: "middle",
                color: "#2A2C2D",
              }}
            >
              Enter URL link <span style={{ color: "#E53935" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="URL@domain.com"
              value={newUrl}
              onChange={(e) => addNewURL(e.target.value)}
              error={!!urlError}
              helperText={urlError}
              sx={{ mb: 3 }}
            />
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontFamily: "Roboto",
                    fontWeight: 600,
                    fontStyle: "SemiBold",
                    fontSize: "16px",
                    leadingTrim: "NONE",
                    lineHeight: "100%",
                    letterSpacing: "0px",
                    verticalAlign: "middle",
                    color: "#2A2C2D",
                  }}
                >
                  Select Country <span style={{ color: "#E53935" }}>*</span>
                </Typography>
                <Select
                  fullWidth
                  value={newCountry}
                  displayEmpty
                  onChange={(e) => { AddNewCountries(e.target.value);}}
                  renderValue={(selected) =>
                    selected ? (
                      europeanCountries.find((c) => c.iso3Code === selected)?.name
                    ) : (
                      <span style={{ color: "#757575" }}>Country</span>
                    )
                  }
                >
                  <MenuItem value="">
                    <span style={{ color: "#757575" }}>Country</span>
                  </MenuItem>
                  {europeanCountries.map((country) => (
                    <MenuItem key={country.iso3Code} value={country.iso3Code}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontFamily: "Roboto",
                    fontWeight: 600,
                    fontStyle: "SemiBold",
                    fontSize: "16px",
                    leadingTrim: "NONE",
                    lineHeight: "100%",
                    letterSpacing: "0px",
                    verticalAlign: "middle",
                    color: "#2A2C2D",
                  }}
                >
                  Select Language <span style={{ color: "#E53935" }}>*</span>
                </Typography>
                <Select
                  fullWidth
                  value={newLanguage}
                  onChange={(e) =>  AddnewLanguage(e.target.value)}
                >
                  {languages.length > 0 &&
                    languages.map((lang) => (
                      <MenuItem key={lang} value={lang}>
                        {lang}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "flex-end", pb: 2, marginRight: "21px" }}
        >
          <Button
            sx={{
              width: 100,
              height: 36,
              borderRadius: "4px",
              angle: "0 deg",
              opacity: 1,
              gap: "8px",
              paddingTop: "10px",
              paddingRight: "14px",
              paddingBottom: "10px",
              paddingLeft: "14px",
              background: "#1214151A",
              fontFamily: "Roboto",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "14px",
              leadingTrim: "NONE",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#2A2C2D",
              borderColor: "#12141533",
            }}
            onClick={handleCloseAddDialog}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={createNewURL}
            variant="contained"
            sx={{ ml: 2, background: "#1976d2" }}
            disabled={!newUrl || !newCountry || !newLanguage || urlError !== "" ||   sessionStorage.getItem("readonly_OemAdmin") === "true"}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DSAComplaintUrl;
